<mat-form-field
  appearance="outline"
  [class]="getClasses()"
>
  <mat-label>{{ label }}</mat-label>
  <input
    #inputElement
    matInput
    class="mat-select-input"
    [(ngModel)]="selectedValue"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="handleSearchTermChange($event)"
    (keydown)="handleKeyEvent($event)"
    (focusin)="handleSelectClick()"
  >
  <mat-select
    #matSelect
    [(ngModel)]="selectedValueId"
    (selectionChange)="handleSelectionChange($event)"
  >
    @if (!isEmptyOptions && needEmptyValue) {
      <mat-option value=""></mat-option>
    }
    @for (option of getSelectData(); track $index) {
      <mat-option
        [class.mat-option-select]="option.id === selectedIndex"
        [style.background-color]="getColorWithOpacity(option.color, 0.35)"
        [value]="option.id.toString()"
      >
        {{ option.value }}
      </mat-option>
    }
    @if (isEmptyOptions) {
      <div class="empty-options">
        Нет данных
      </div>
    }
  </mat-select>
</mat-form-field>
